import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { BaseStyleClassesDirective, PortalId } from '@gk/gk-modules';
import { Observable } from 'rxjs';
import { BaseNewRequestControlName } from '../base-new-request-form/base-new-request-form.model';
import { DocumentationFormType } from '../base-new-request/base-new-request.model';
import { ShippingFormComponent } from '../shipping-form/shipping-form.component';
import { Shipping } from '../shipping-form/shipping-form.model';

@Component({
  selector: 'app-request-reply-form',
  templateUrl: './request-reply-form.component.html',
  styleUrl: './request-reply-form.component.scss',
  standalone: false,
})
export class RequestReplyFormComponent
  extends BaseStyleClassesDirective
  implements OnChanges
{
  @Input() submitted: boolean;
  @Input() formGroup: UntypedFormGroup;
  @Input() portalId: PortalId;
  @Input() nonElectronicForm = true;
  @Input() electronicForm = true;
  @ViewChild(ShippingFormComponent)
  shippingFormComponent: ShippingFormComponent;
  documentationFormType = DocumentationFormType;
  controlName = BaseNewRequestControlName;

  ngOnChanges(changes: SimpleChanges): void {
    const electronicFormChange = changes['electronicForm'];
    const nonElectronicFormChange = changes['nonElectronicForm'];
    this.setProperDocumentationFormTypeOnVisibilityChange(
      electronicFormChange && electronicFormChange.currentValue !== true,
      nonElectronicFormChange && nonElectronicFormChange.currentValue !== true,
    );
  }

  setProperDocumentationFormTypeOnVisibilityChange(
    isElectronicFormInvisible: boolean,
    isNonElectronicFormInvisible: boolean,
  ): void {
    if (isElectronicFormInvisible && this.isElectronicForm()) {
      this.getDocumentationFormRadioFormControl()?.setValue(
        DocumentationFormType.NonElectronicForm,
      );
    }

    if (isNonElectronicFormInvisible && this.isNonElectronicForm()) {
      this.getDocumentationFormRadioFormControl()?.setValue(
        DocumentationFormType.ElectronicForm,
      );
    }
  }

  isElectronicForm(): boolean {
    return (
      this.getDocumentationFormRadioFormControl()?.value ===
      DocumentationFormType.ElectronicForm
    );
  }

  isNonElectronicForm(): boolean {
    return (
      this.getDocumentationFormRadioFormControl()?.value ===
      DocumentationFormType.NonElectronicForm
    );
  }

  checkShippingFormGroupValidAndFormSubmitted(): boolean {
    return !this.getShippingFormGroup().valid && this.submitted;
  }

  getShippingFormGroup(): UntypedFormGroup {
    return this.formGroup.get(
      this.controlName.ShippingForm,
    ) as UntypedFormGroup;
  }

  getDocumentationFormRadioFormControl(): AbstractControl {
    return this.formGroup.get(this.controlName.DocumentationForm);
  }

  askForPostOfficeWhenPostalCodeIsNotFromDictionary(): Observable<boolean> {
    return this.shippingFormComponent.askForPostOfficeWhenPostalCodeIsNotFromDictionary();
  }

  patchRequestReplyFormControls({
    documentationForm,
    shippingForm,
  }: {
    documentationForm: DocumentationFormType;
    shippingForm: Shipping;
  }): void {
    this.formGroup.patchValue(
      {
        documentationForm: documentationForm,
      },
      { emitEvent: false },
    );
    this.shippingFormComponent.setShippingForm(shippingForm);
    this.formGroup.patchValue({
      shippingForm: {
        ...shippingForm,
        addressSelect: undefined,
      },
    });
  }
}
